import { ChangeDetectorRef, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { IAssetStorageEntry } from '../asset-storage-entry';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { GridModule, RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { AssetCollectionDTO, IAssetCollectionDTO } from 'src/app/base/models/models.swagger.generated';
import { AssetCollectionsService } from '../../asset-collections/asset-collections.service';
import { AssetStorageService } from '../asset-storage.service';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';

@Component({
    selector: 'app-asset-storage-collections',
    templateUrl: './asset-storage-collections.component.html',
    styleUrls: ['./asset-storage-collections.component.scss'],
    imports: [
        DialogModule,
        GridModule,
        TranslateModule,
        FormsModule
    ]
})
export class AssetStorageCollectionsComponent {

  @ViewChild('collectionsDialog') private collectionsDialog: DialogComponent;
  @Output() public collectionsChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  public allCollections: IAssetCollectionDTO[] = [];
  public selectedCollections: IAssetCollectionDTO[] = [];
  public isSaveDisabled: boolean = true;
  public filterSettings = GridConstantsFactory.createStandardFilterSettings();

  public assets: IAssetStorageEntry[];
  public customEditSettings = {
    allowEditing: false,
    allowAdding: false,
  };

  constructor(
    private assetCollectionsService: AssetCollectionsService,
    private assetStorageService: AssetStorageService,
    private cdr: ChangeDetectorRef
  ) { }

  public openCollections(assets: IAssetStorageEntry[]) {
    this.assets = assets;
    this.isSaveDisabled = true;
    this.assetCollectionsService.getAllCollections().subscribe(collections => {
      this.allCollections = collections;
      this.collectionsDialog.show();
      this.cdr.detectChanges();
    });
  }

  public onCancel() {
    this.collectionsDialog.hide();
  }

  public onCheckboxChange(args: any, collection: AssetCollectionDTO) {
    if (args.target.checked) {
      this.selectedCollections.push(collection);
      //this.asset.linkedAssetCollections.push(collection);
    } else {
      //this.asset.linkedAssetCollections = this.asset.linkedAssetCollections.filter(c => c.id !== collection.id);
      this.selectedCollections = this.selectedCollections.filter(c => c.id !== collection.id);
    }
    this.isSaveDisabled = false;
  }

  public onSave() {
    this.assetStorageService.setAssignedCollectionsForAssets(this.assets.map(a => a.entryId), this.selectedCollections.map(a => a.id)).subscribe(() => {
      this.collectionsDialog.hide();
      this.collectionsChange.emit();
      this.selectedCollections = [];
    });
  }

  public onRowDataBound(args: RowDataBoundEventArgs) {
    if (args.data) {
      const data = args.data as IAssetCollectionDTO;
      // check if collection is assigned to any one of the assets
      const isAssigned = this.assets.some(asset =>
        asset.linkedAssetCollections?.some(c => c.id === data.id)
      );
      // find the checkbox column and mark as checked or unchecked
      const checkbox = args.row.querySelector("input[type='checkbox']");
      if (checkbox && isAssigned) {
        this.selectedCollections.push(data);
        checkbox.setAttribute('checked', 'checked');
      }
    }
  }
}
